import React from 'react';
import { Reveal } from './Reveal';
const problems = ['You show up to class without a real structured plan.', 'You spend hours searching for choreography ideas before every session.', 'You repeat the same step patterns because you have no planned variety.', 'A student walks in with knee pain or mobility issues — and you freeze.', 'There’s no real progression — every class feels disconnected from the last.', 'Students stop coming because they don’t see measurable results.', 'You have zero professional documentation backing up your work.'];
export function Problems() {
  return <section className="w-full bg-mist px-4 py-20 text-ink sm:py-24" data-id="element-176" data-mp="2j66nyqyeagps">
      <div className="mx-auto max-w-3xl" data-id="element-177" data-mp="2j89erd7dgdvk">
        <Reveal className="text-center" data-id="element-178" data-mp="2f53auc7qeys9">
          <h2 className="font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl" data-id="element-179" data-mp="2f664ut0cphce">
            How many more step classes are you going to <span className="text-teal" data-id="element-180" data-mp="ddhxq8kl69rc">improvise?</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-181" data-mp="dbdt1oev56q0">
            If you’re a step instructor, you’ve probably lived every one of these moments:
          </p>
        </Reveal>
        <ul className="mt-10 space-y-3" data-id="element-182" data-mp="39qr3k9op3zur">
          {problems.map((problem, index) => <Reveal key={problem} delay={index * 0.035} data-id="element-183" data-mp="2vqyiouzuodup" data-mpi={index}>
              <li className="flex gap-3 rounded-xl border border-ink/10 bg-surface p-5 text-sm leading-relaxed text-slate shadow-premium sm:text-base" data-id="element-184" data-mp="2vsjcgiecbsri">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-ink/20 text-xs text-ink/60" data-id="element-185" data-mp="3nie3qklrdsit">
                  ✕
                </span>
                {problem}
              </li>
            </Reveal>)}
        </ul>
        <Reveal data-id="element-186" data-mp="3iqmjssx3yl1n">
          <p className="mt-10 text-center font-display text-2xl font-bold italic text-teal sm:text-3xl" data-id="element-187" data-mp="3iq4ez7wdqyi4">
            “It’s not lack of effort. It’s lack of system.”
          </p>
        </Reveal>
      </div>
    </section>;
}